import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/MaintenanceTypeActions";
import * as api from "../../api/MaintenanceTypeApi";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";


function* getMaintenanceType() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getMaintenanceType();
        yield put(actions.setMaintenanceType(data.resultObject || undefined));
    } catch (error) {
        yield put(actions.setMaintenanceType(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getMailGroup() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getMailGroup();
        yield put(actions.setMailGroup(data.resultObject || undefined));
    } catch (error) {
        yield put(actions.setMailGroup(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getMailGroupPeriod() {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getMailGroupPeriod();
        yield put(actions.setMailGroupPeriod(data.resultObject || undefined));
    } catch (error) {
        yield put(actions.setMailGroupPeriod(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getPlants() {
    try {
        const { data } = yield api.getPlants();
        yield put(actions.setPlants(data || undefined));
    } catch (error) {
        yield put(actions.setPlants(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}


function* addMaintenanceType(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addMaintenanceType(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateMaintenanceType(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateMaintenanceType(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteMaintenanceType(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.deleteMaintenanceType(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_MAINTENANCE_TYPE, getMaintenanceType);
    yield takeEvery(actions.Types.GET_MAIL_GROUP, getMailGroup);
    yield takeEvery(actions.Types.GET_MAIL_GROUP_PERIOD, getMailGroupPeriod);
    yield takeEvery(actions.Types.GET_PLANTS, getPlants);
    yield takeEvery(actions.Types.ADD_MAINTENANCE_TYPE, addMaintenanceType);
    yield takeEvery(actions.Types.UPDATE_MAINTENANCE_TYPE, updateMaintenanceType);
    yield takeEvery(actions.Types.DELETE_MAINTENANCE_TYPE, deleteMaintenanceType);
}

const MaintenanceTypeSaga = [fork(watchAll)];

export default MaintenanceTypeSaga;
